import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "96790a41-2985-4d96-b46c-525cdc048911",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin + "/auth-redirect.html",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginScopes = {
  scopes: [
    "User.Read",
    "OnlineMeetings.ReadWrite",
    "Calendars.ReadWrite",
    "Mail.Send",
    "Mail.ReadWrite",
  ],
};

export const msalInstance = new PublicClientApplication({
  ...msalConfig,
  cache: { cacheLocation: "localStorage", storeAuthStateInCookie: false },
});
